import React, { useEffect, useState } from "react";

import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
// import TableHead from "@material-ui/core/TableHead";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
// import TableSortLabel from "@material-ui/core/TableSortLabel";
// import Toolbar from "@material-ui/core/Toolbar";
// import Typography from "@material-ui/core/Typography";
// import Checkbox from "@material-ui/core/Checkbox";
// import IconButton from "@material-ui/core/IconButton";
// import Tooltip from "@material-ui/core/Tooltip";
// import FormControlLabel from "@material-ui/core/FormControlLabel";

import CircularProgress from "@material-ui/core/CircularProgress";

// import BooleanTypeProvider from "./boolean-type-provider";
// import PermissionLevelTypeProvider from "./permission-level-type-provider";
// import DashboardStatusTypeProvider from "./dashboard-status-type-provider";

import StatusLed from "./components/status-led/status-led";

// import { useAuth } from "./use-auth";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      // minWidth: 500,
      height: "100%",
    },
  })
);

interface Props {
  dataSource: { [key: string]: any }[];
  changeVariables: any;
  loading: boolean;
  totalElements?: number;

  // TODO probably this belongs to the container!
  createEntityMutation?: any;
  updateEntityMutation?: any;
  deleteEntityMutation?: any;

  // TODO naming! (e.g., onViewClick, onEditClick, onDeleteClick)
  onView: any;
  onEdit: any;
  onDelete: any;
}

function DashboardTableDx(props: Props) {
  const classes = useStyles(props);
  const {
    dataSource = [],
    changeVariables,
    loading,
    totalElements,
    // createEntityMutation,
    // updateEntityMutation,
    // deleteEntityMutation,
    onView,
    // onEdit,
    // onDelete,
  } = props;

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [columns /*, setColumns*/] = useState([
    // { id: "command", title: " " },
    // { id: "id", label: "Id" },
    {
      id: "status",
      label: "Status",
      width: 24 + 8 + 20,
      format: ({ value }: any) => <StatusLed status={value} />,
    },
    { id: "title", label: "Title" },
    // { id: "owner", label: "Owner" },
    // { id: "group", label: "Group" },
    // { id: "permissionOwner", label: "Permission Owner" },
    // { id: "permissionGroup", label: "Permission Group" },
    // { id: "permissionOther", label: "Permission Other" },
    // { id: "publicAvailable", label: "Public Available" },
  ]);

  let rows = dataSource ? dataSource : []; // ? dataSource.map(row => Object.assign({ command: row.id }, row)) : []; // TODO Fix!
  // rows = rows.map(row => Object.assign({ status: row.id }, row));

  const totalCount = totalElements ? totalElements : rows ? rows.length : 0; // TODO improve this!

  // TODO This variables part is Apollo specificy
  const variables: any = {};
  // if (sorting && sorting.length > 0) {
  //   // TODO multisort?
  //   variables.orderBy = sorting.map(
  //     (s) => `${s.columnName}_${s.direction.toUpperCase()}`
  //   )[0];
  // }
  if (rowsPerPage && rowsPerPage > 0) {
    variables.first = /* TODO currentPage * ??? */ rowsPerPage;
  }
  // TODO variables.after
  if (page && page > 0) {
    variables.skip = page * rowsPerPage;
  }

  useEffect(() => {
    changeVariables(variables);
  }, [changeVariables, variables]);
  // changeVariables(variables);

  // const emptyRows =
  //   rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <TableContainer className={classes.container}>
      <Table stickyHeader>
        {/* <TableHead>
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={column.id}
            // align={column.align}
            style={{ width: column.width }}
          >
            {column.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead> */}
        <TableBody>
          {rows.length === 0 && (
            <TableCell
              colSpan={columns.length}
              align="center"
              style={{ textAlign: "center", verticalAlign: "middle" }}
            >
              <big>
                {loading ? <CircularProgress size={28} /> : <>No data</>}
              </big>
            </TableCell>
          )}
          {rows.map((row) => (
            <TableRow
              key={row.name}
              style={{ cursor: "pointer" }}
              onClick={(event: any) => onView(row, event)}
            >
              {columns.map((column) => {
                const value = row[column.id];
                return (
                  <TableCell
                    key={column.id}
                    // align={column.align}
                    style={{ width: column.width }}
                  >
                    {column.format ? column.format({ value, row }) : value}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
          {/* {emptyRows > 0 && (
        <TableRow style={{ height: 53 * emptyRows }}>
          <TableCell colSpan={columns.length} />
        </TableRow>
      )} */}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                25,
                // , { label: 'All', value: -1 }
              ]}
              colSpan={columns.length}
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              // ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}

export default DashboardTableDx;
